// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3uXfy","signatureButtonsRight":"ModalSign_signatureButtonsRight__cMgp-"};